import styled from "styled-components";
import { Link } from "react-scroll";
import DevkeyLogo from "./../assets/images/devkey_logo.png";
import { mobileMaxWidth, colors, fonts, spacing, transitions } from "../theme";

const Wrapper = styled.footer`
  background-color: ${colors.ink};
  padding: 72px ${spacing.sectionX} 40px;
`;

const Inner = styled.div`
  max-width: ${spacing.maxWidth};
  margin: 0 auto;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;

  @media screen and (max-width: ${mobileMaxWidth}) {
    flex-direction: column;
  }
`;

const CompanyIcon = styled.img`
  height: 32px;
  width: auto;
`;

const Body = styled.p`
  max-width: 380px;
  margin: 20px 0 0;
  font-size: 15px;
  font-family: ${fonts.body};
  color: ${colors.textOnDarkMuted};
  line-height: 1.65;
`;

const Nav = styled.nav`
  display: flex;
  gap: 32px;

  a {
    color: ${colors.textOnDarkMuted};
    font-family: ${fonts.body};
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: ${transitions.fast};

    &:hover {
      color: ${colors.white};
    }
  }
`;

const Bottom = styled.div`
  margin-top: 56px;
  padding-top: 24px;
  border-top: 1px solid ${colors.borderDark};
  color: ${colors.textLight};
  font-family: ${fonts.body};
  font-size: 14px;
`;

const Footer = () => {
  return (
    <Wrapper>
      <Inner>
        <Top>
          <div>
            <CompanyIcon src={DevkeyLogo} alt="devKey" />
            <Body>
              Egna appar, byggda från grunden och använda av tusentals människor
              varje dag.
            </Body>
          </div>
          <Nav>
            <Link to="home" smooth={true} offset={-100} duration={400}>
              Hem
            </Link>
            <Link to="ourProjects" smooth={true} offset={-100} duration={400}>
              Våra appar
            </Link>
            <Link to="contact" smooth={true} offset={-100} duration={400}>
              Kontakt
            </Link>
          </Nav>
        </Top>
        <Bottom>© {new Date().getFullYear()} devkey Software</Bottom>
      </Inner>
    </Wrapper>
  );
};

export default Footer;
